import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'portal-ui-unable-to-proceed',
  standalone: true,
  imports: [],
  template: `<p>Unable to proceed with this application. Please contact your Relationship Manager.</p>`,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnableToProceedComponent {}
